/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createViewCartShareMessageResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ViewCartShareMessageResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/messagecenter/carts/{messageId}
 */
export interface WithMessageItemRequestBuilder extends BaseRequestBuilder<WithMessageItemRequestBuilder> {
    /**
     * Returns the cart as the sales rep shared it — lines, totals, the rep's note, sender and organization details. The snapshot was taken when the message was sent, so it does not change when the cart is later edited, checked out or deleted. Fully anonymous — no authentication required.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ViewCartShareMessageResponse>}
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {ErrorResponse} error when the service returns a 429 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ViewCartShareMessageResponse | undefined>;
    /**
     * Returns the cart as the sales rep shared it — lines, totals, the rep's note, sender and organization details. The snapshot was taken when the message was sent, so it does not change when the cart is later edited, checked out or deleted. Fully anonymous — no authentication required.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithMessageItemRequestBuilderUriTemplate = "{+baseurl}/api/messagecenter/carts/{messageId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithMessageItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithMessageItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createViewCartShareMessageResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
